var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container mx-auto my-20 px-4 max-w-6xl" }, [
    _c(
      "div",
      { staticClass: "grid md:grid-cols-5 gap-6 bg-gray-50 p-4 rounded-lg" },
      [
        _c("div", { staticClass: "md:col-span-3" }, [
          _c(
            "div",
            { staticClass: "flex justify-between items-center text-gray-600" },
            [
              _c(
                "button",
                {
                  staticClass: "focus:outline-none",
                  class: { invisible: _vm.hidePreviousMonthArrow },
                  on: {
                    click: function ($event) {
                      return _vm.previousMonth()
                    },
                  },
                },
                [
                  _c(
                    "svg",
                    {
                      staticClass: "h-5 w-5",
                      attrs: {
                        xmlns: "http://www.w3.org/2000/svg",
                        fill: "none",
                        viewBox: "0 0 24 24",
                        stroke: "currentColor",
                      },
                    },
                    [
                      _c("path", {
                        attrs: {
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                          "stroke-width": "2",
                          d: "M15 19l-7-7 7-7",
                        },
                      }),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(_vm.selectedMonth))]),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "focus:outline-none",
                  on: {
                    click: function ($event) {
                      return _vm.nextMonth()
                    },
                  },
                },
                [
                  _c(
                    "svg",
                    {
                      staticClass: "h-5 w-5",
                      attrs: {
                        xmlns: "http://www.w3.org/2000/svg",
                        fill: "none",
                        viewBox: "0 0 24 24",
                        stroke: "currentColor",
                      },
                    },
                    [
                      _c("path", {
                        attrs: {
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                          "stroke-width": "2",
                          d: "M9 5l7 7-7 7",
                        },
                      }),
                    ]
                  ),
                ]
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "grid grid-cols-7 gap-1 mt-4" },
            [
              _c("div", { staticClass: "text-gray-500 text-center pb-2" }, [
                _vm._v("Mo"),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "text-gray-500 text-center pb-2" }, [
                _vm._v("Tu"),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "text-gray-500 text-center pb-2" }, [
                _vm._v("We"),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "text-gray-500 text-center pb-2" }, [
                _vm._v("Th"),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "text-gray-500 text-center pb-2" }, [
                _vm._v("Fr"),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "text-gray-500 text-center pb-2" }, [
                _vm._v("Sa"),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "text-gray-500 text-center pb-2" }, [
                _vm._v("Su"),
              ]),
              _vm._v(" "),
              _vm._l(_vm.days, function (day) {
                return _c(
                  "button",
                  {
                    staticClass:
                      "relative ratio-1:1 rounded text-gray-500 focus:outline-none transition-colors duration-300 ease-in-out",
                    class: {
                      "bg-gray-100": day.isPast,
                      "bg-gray-200":
                        !day.isPadding && !day.isPast && !day.isToday,
                      "bg-primary-200": day.isToday,
                      "bg-primary-600 text-primary-200":
                        day === _vm.selectedDay,
                      "cursor-default": day.isPadding,
                    },
                    on: {
                      click: function ($event) {
                        return _vm.selectDay(day)
                      },
                    },
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass:
                          "absolute inset-0 pointer-events-none sm:pt-2 px-1 sm:px-3 text-right text-sm sm:text-base",
                      },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(day.date) +
                            "\n                    "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass:
                          "absolute inset-0 pointer-events-none pb-2",
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass:
                              "h-full flex items-end justify-center space-x-0.5 sm:space-x-1",
                          },
                          _vm._l(_vm.events[day.date], function (event) {
                            return _c("span", {
                              staticClass:
                                "block w-2 sm:w-3 h-2 sm:h-3 rounded-full",
                              class: event.colour,
                            })
                          }),
                          0
                        ),
                      ]
                    ),
                  ]
                )
              }),
            ],
            2
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "md:col-span-2" }, [
          _c("div", { staticClass: "flex flex-col justify-between h-full" }, [
            _c(
              "div",
              [
                _vm._m(0),
                _vm._v(" "),
                _vm._l(_vm.filteredEvents, function (date) {
                  return _vm._l(date, function (event) {
                    return !_vm.hideFullyBooked || event.seats > 0
                      ? _c(
                          "a",
                          {
                            staticClass: "block hover:bg-gray-100 p-2 rounded",
                            attrs: { href: `/${event.url}` },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "flex justify-between items-center",
                              },
                              [
                                _c("div", { staticClass: "leading-6" }, [
                                  _c(
                                    "div",
                                    { staticClass: "flex items-start" },
                                    [
                                      _c("div", {
                                        staticClass:
                                          "w-3 h-3 rounded-full flex-shrink-0 mt-1.5",
                                        class: event.colour,
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "ml-2 text-lg text-gray-700 font-medium",
                                        },
                                        [_vm._v(_vm._s(event.name))]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("div", {
                                    staticClass: "text-gray-500 pl-5",
                                    domProps: { innerHTML: _vm._s(event.date) },
                                  }),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "text-sm text-gray-500 text-right",
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "font-semibold" },
                                      [_vm._v(_vm._s(event.type))]
                                    ),
                                    _vm._v(" "),
                                    event.seats > 0
                                      ? _c("div", [
                                          _vm._v(
                                            "\n                                        " +
                                              _vm._s(event.seats) +
                                              " Seat" +
                                              _vm._s(
                                                event.seats !== 1 ? "s" : ""
                                              ) +
                                              " Available\n                                    "
                                          ),
                                        ])
                                      : _c("div", [_vm._v("Fully Booked")]),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        )
                      : _vm._e()
                  })
                }),
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "flex justify-between items-center mt-6" },
              [
                _c(
                  "div",
                  { staticClass: "flex items-center" },
                  [
                    _c("form-toggle", {
                      staticClass: "mr-1",
                      model: {
                        value: _vm.hideFullyBooked,
                        callback: function ($$v) {
                          _vm.hideFullyBooked = $$v
                        },
                        expression: "hideFullyBooked",
                      },
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "text-gray-600" }, [
                      _vm._v("Hide fully booked events"),
                    ]),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "relative group" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "text-sm text-gray-500 font-semibold cursor-default",
                    },
                    [_vm._v("Key")]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "absolute pointer-events-none bottom-0 right-full z-10 bg-gray-800 px-3 py-2 mr-1 rounded opacity-0 transition-opacity duration-200 ease-in-out group-hover:opacity-100",
                    },
                    _vm._l(_vm.types, function (type) {
                      return _c("div", { staticClass: "flex items-center" }, [
                        _c("div", {
                          staticClass: "w-3 h-3 rounded-full flex-shrink-0",
                          class: type.calendar_colour,
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "ml-2 text-white font-medium whitespace-no-wrap",
                          },
                          [_vm._v(_vm._s(type.name))]
                        ),
                      ])
                    }),
                    0
                  ),
                ]),
              ]
            ),
          ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "flex justify-between items-center" }, [
      _c("h3", { staticClass: "mb-2" }, [_vm._v("Events")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }